import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { map, first } from 'rxjs/operators';
import { ACResourceService } from '@appcatalyst/ng-cms-core-lib';

@Injectable({
  providedIn: 'root'
})
export class PluginsService {
  private plugins = new ReplaySubject<any>(1);
  private pluginsPicker = new ReplaySubject<any>(1);

  constructor(private cms: ACResourceService) { }

  public updatePlugins = (params: any) => {
    var path = `/plugins`
    return this.cms.request('GET', path, params).pipe(
      first(),
      map(data => {
        this.plugins.next(data)
        return data
      })
    )
  }

  public getPlugins = (): Observable<any> => {
    return this.plugins.asObservable()
  }

  public updatePluginsPicker = () => {
    var path = `/plugins`
    return this.cms.request('GET', path).pipe(
      first(),
      map(body => {
        this.pluginsPicker.next(body.data)
        return body.data
      })
    )
  }

  public getPluginsPicker = (): Observable<any> => {
    return this.pluginsPicker.asObservable()
  }
}
